import * as Yup from "yup";

export const resetPasswordInitialValues = {
  new_password: "",
  confirm_password: ""
};

export const ResetPasswordSchema = Yup.object().shape({
  new_password: Yup.string()
    .required("New Password is required"),
  confirm_password: Yup.string()
    .required("Confirm pasword required")
    .oneOf([Yup.ref("new_password"), null], "Password must match"),
});

export const setPasswordInitialValues = {
  new_password: "",
  confirm_password: ""
};

export const SetPasswordSchema = Yup.object({
  new_password: Yup.string().required('New password is required'),
  confirm_password: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref("new_password"), null], "Password must match")
});

export const forgotPasswordInitialValues = {
  email: '',
};
export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Must be a valid email')
    .max(255)
    .required('Email is required'),
});

export const signInInitialValues = {
  email: '',
  password: '',
  rememberMe: true
};
export const SignInSchema = Yup.object().shape({
  email: Yup.string()
    .email('Must be a valid email')
    .max(255)
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
  rememberMe: Yup.boolean().required('Remember Me is required'),
});

export const signUpInitialValues = {
  email: '',
  refferal: '',
};
export const SignUpSchema = Yup.object().shape({
  email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
  refferal: Yup.string().min(5).max(15),
});

export const createPasswordInitialValues = {
  first_name: "",
  last_name: "",
  password: "",
  confirm_password: ""
}

export const CreatePasswordSchema = Yup.object().shape({
  first_name: Yup.string().required("Prénom requis"),
  last_name: Yup.string().required("Nom de famille requis"),
  password: Yup.string().min(8, "Minimum 8 caractères").required("Mot de passe requis"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Les mots de passe ne correspondent pas")
    .required("Confirmation requise"),
});